import React, {useEffect, useState} from "react";
import TopBarPanel from "./TopBarPanel";
import axios from 'axios';


const TopBar = ({ empID = null, employerTopPanel, rightSideComponent=<></>   } ) => {
    const [data, setData] = useState(null);
    const [loaderCommission, setloaderCommission] = useState(true)
    const getTopBarData = () => {
        setloaderCommission(true);
        setData(null);
        axios.get(process.env.REACT_APP_BASE_URL + '/enrollment/getTotalOfMemberByAgentId/' + JSON.parse(sessionStorage.getItem('USER_DATA'))?.agentId)
        .then(response =>{
            setData(response.data.response)
            setloaderCommission(false)
        });
    }
    useEffect(() => {
        getTopBarData()
    }, [])

    if(employerTopPanel)
        return employerTopPanel;
    else if(empID)
    return (
        <div>
            <TopBarPanel
                         paneldata={[
                            {
                            label: "Total Employers PROSPECTED",
                            value: data && data.emplopyer ? data.emplopyer.prospectCount : "-",
                            size: 1.5,
                            },
                            {
                            label: "Total Employers ENROLLED",
                            value: data && data.emplopyer ? data.emplopyer.enrollCount : "-",
                            size: 1.3,
                            },
                            {
                                label: "Total Employers IN PROGRESS",
                                value: data && data.emplopyer ? data.emplopyer.notEnrollCount : "-",
                                size: 1.5,
                                },
                                {
                                    label: "Total Monthly Share PROSPECTED",
                                    value: data && data.emplopyer ? "$" + data.emplopyer.prospectedAmount : "-",
                                    size: 1.5,
                                    },
                                    {
                                        label: "Total Monthly Contribution ENROLLED",
                                        value: data && data.emplopyer ? "$" + data.emplopyer.enrollAmount : "-",
                                        size: 1.8,
                                        },
                                        {
                                            label: "Total Monthly Share IN PROGRESS",
                                            value: data && data.emplopyer ? "$" + data.emplopyer.notEnrollAmount : "-",
                                            size: 1.5,
                        },
                        ]}
                        rightSideComponent={<div className="label-container" style={{ fontSize: 9 }}>
                        <img
                          style={{
                            width: "30px",
                            height: "30px",
                            cursor: loaderCommission ? "wait" : "pointer",
                         
                          }}
                          className={loaderCommission ? "imageSpin" : ""}
                          src= {require('./../../../../Assets/Images/reload.png')}
                          onClick={() => (loaderCommission ? {} : getTopBarData())}
                        />
                      </div>}
            />
        </div>)
        else
            return (
                <div>
                     <TopBarPanel
                           paneldata={[
                                    {
                                    label: "Total Households PROSPECTED",
                                    value: data && data.household ? data.household.prospectCount : "-",
                                    size: 1.5,
                                    },
                                    {
                                    label: "Total Households ENROLLED",
                                    value: data && data.household ? data.household.enrollCount : "-",
                                    size: 1.5,
                                    },
                                    {
                                        label: "Total Households IN PROGRESS",
                                        value: data && data.household ? data.household.notEnrollCount : "-",
                                        size: 1.5,
                                        },
                                        {
                                            label: "Total Monthly Share PROSPECTED",
                                            value: data && data.household ? "$" + data.household.prospectedAmount : "-",
                                            size: 1.5,
                                            },
                                            {
                                                label: "Total Monthly Contribution ENROLLED",
                                                value: data && data.household ? "$" + data.household.enrollAmount : "-",
                                                size: 1.8,
                                                },
                                                {
                                                    label: "Total Monthly Share IN PROGRESS",
                                                    value: data && data.household ? "$" + data.household.notEnrollAmount : "-",
                                                    size: 1.5,
                                },
                                ]}
                                rightSideComponent={<div className="label-container" style={{ fontSize: 9 }}>
                                <img
                                  style={{
                                    width: "30px",
                                    height: "30px",
                                    cursor: loaderCommission ? "wait" : "pointer",
                              
                                  }}
                                  className={loaderCommission ? "imageSpin" : ""}
                                  src={require("./../../../../Assets/Images/reload.png")}
                                  onClick={() => (loaderCommission ? {} : getTopBarData())}
                                />
                              </div>}
                           />
    </div>
  );
}
export default TopBar;